import { useGetSubscriptionsQuery } from "../Redux/api/subscriptionApi";
import { SubscriptionTier } from "../Types/Client";

export type tier = 'starter' | 'premium' | 'premium_africa' | 'enterprise'
interface useSubscriptionProps {}

export const useSubscription = () => {
    /* ******************** Hooks ******************** */
    const { data: subscriptions, isLoading, isFetching } = useGetSubscriptionsQuery();
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const getSubscription = ( tier: tier ) => {
        return subscriptions?.find( s => s.tier == tier)
    }
    const formatSubscriptionPrice = ( tier: tier, isMonthly: boolean ) => {
        switch(tier) {
            case SubscriptionTier.Starter:
                return 'Free';
            case SubscriptionTier.Enterprise:
                return 'Contact us for a free quote';
            default:
                const subscription = getSubscription(tier);
                return isMonthly ? `$${subscription?.monthly_price}/mo` : `$${subscription?.annual_price}/year`
        }
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return {
        subscriptions,
        subscriptionsLoading: isLoading || isFetching,
        getSubscription,
        formatSubscriptionPrice
    }
}